import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { WECAPTURE_URL, WECAPTURE_AUTHOR_TYPE, WECAPTURE_IMAGE_TYPE } from "./constants";

function getImageType({ currentTime, pickUp, dropOff }) {
  // const timeInputFormat = "DD-MM-YYYY HH:mm";
  const timeInputFormat = "YYYY-MM-DD HH:mm";
  const currentMoment = moment(currentTime);

  const pickupMoment = moment(pickUp, timeInputFormat);
  const oneHourIntoRental = pickupMoment.clone().add(1, "hour");
  if (currentMoment.isSameOrBefore(oneHourIntoRental)) {
    return WECAPTURE_IMAGE_TYPE.preRental;
  }

  const dropoffMoment = moment(dropOff, timeInputFormat);
  if (currentMoment.isSameOrAfter(dropoffMoment)) {
    return WECAPTURE_IMAGE_TYPE.postRental;
  }

  return WECAPTURE_IMAGE_TYPE.rental;
}

export function buildMetadata({
  vehicleNumber,
  raNumber,
  latitude,
  longitude,
  country,
  pickUp,
  dropOff,
}) {
  const batch = uuidv4();
  const currentTime = moment();
  const hertz_timestamp = currentTime.format("YYYY-MM-DDTHH:mm:ssZ");
  const imageType = getImageType({ currentTime, pickUp, dropOff });

  return {
    batch,
    unit_number: vehicleNumber,
    hertz_timestamp,
    author: WECAPTURE_AUTHOR_TYPE.customer,
    type: imageType,
    author_id: raNumber,
    latitude,
    longitude,
    country,
  };
}

function buildMetadataFile(metadata) {
  return new Blob([JSON.stringify(metadata)], { type: "application/json" });
}

async function uploadReducer(results, photo, metadata) {
  try {
    const resultsQueue = await results;

    const body = new FormData();
    body.append("metadata", metadata, "metadata.json");
    body.append("files", photo, photo.name);

    const result = await fetch(WECAPTURE_URL, {
      method: "POST",
      mode: "cors",
      body,
    }).then((result) => result.json());

    resultsQueue.push(result);
    return resultsQueue;
  } catch (error) {
    console.error("CANNOT UPLOAD PRE-RENTAL PHOTO.", error);
    const resultsQueue = await results;
    resultsQueue.push({ success: 0 });
    return resultsQueue;
  }
}

export const uploadPhotosToWecapture = async (photos, metadata) => {
  const metadataFile = buildMetadataFile(metadata);
  return photos.reduce(async (results, photo) => uploadReducer(results, photo, metadataFile), []);
};

export const base64ToUint8Array = (base64) => {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const uint8ArrayToBase64 = (uint8Array) => {
  let binaryString = "";
  for (let i = 0; i < uint8Array.length; i++) {
    binaryString += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binaryString);
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result); // base64 string
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToFile = (base64String, filename) => {
  const arr = base64String.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
